<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>Events Cluster 📅</h1>
        <h4>The Events Cluster spearheads in managing all event-based projects of the organization throughout its entire timeline of planning, execution, and handling of post-event matters. The goal of the cluster is to organize large-scale activities that promote the organization’s thrusts and cater to the entire organization community and alike. Members of this cluster will learn and be able to apply principles of project management that will aid them in their wide scope of work under the Events Cluster.</h4>

        <!-- MISA REWIND 
        <h2><b>MISA Rewind</b></h2>
        <h4>MISA Rewind is a celebration to wrap up MISA’s 26th year as an organization. The organization will be livestreaming a program that consists of this year’s MISAwards where officers of the org will be awarded for their hard work and achievements and performances to showcase the talent of fellow MISAns. Along with this, the incoming MISA Executive Board will be welcomed, and a culminating activity will happen for all current MISAns and alumni to bond over as the closing event of the school year. </h4>
        -->

        <h3>Positions:</h3>

        <h2><b>Year-End Party (YEP) Project Director</b></h2>
        <h4>The Project Director is expected to lead the entire project team in assuring the success of the project. He ensures proper planning, execution, and evaluation of the project, through the application of project management principles and practices. He communicates with the VP for Events and the respective AVP for the needs of the project. </h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Accomplishes the Project Proposal Form of the event</li>
            <li>In-charge of leading and delegating tasks to the team members</li>
            <li>Facilitates the planning and execution of the project</li>
            <li>Oversees the filing of project proposal forms, budget reports, BETA presentation, and other relevant documents</li>
        </ul>
        <h4>Qualifications:</h4>
        <ul>
            <li>Must have been a core team member of the event they are applying for</li>
            <li>Available to attend on-campus for multiple occasions</li>
        </ul> 

        <!-- <h2><b>Deputy Project Director</b></h2>
        <h4>The Deputy Project Director is tasked to assist the Project Director in leading the entire project team for the duration of the project.</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Handles filling of project proposal form, communicating with other members for the needed parts.</li>
            <li>Assists the Project Director in leading the project.</li>
            <li>Serves as Project Director should the Project Director be absent or can no longer fulfill.</li>
            <li>Communicates with other core team members regarding their assigned tasks.</li>
            <li>Assists the Operations Manager in conducting a SWOT analysis as a post-event processing session.</li>
        </ul> -->

        <h2><b>Programs Officer Pool</b></h2>
        <h4>Works directly with the VP for Events, Assigned AVP for Event, Project Core.</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>In-charge of crafting the program flow and script for the event</li>
            <li>Directly communicates with logistic heads for program files and any other logistical needs/requests (suitable with the chosen online platform/application) in order to execute the crafted program flow</li>
            <li>Along with fellow logistic heads, conducts and facilitates test and dry runs w/ hosts/speakers/volunteers at least 1 week prior to the event</li>
        </ul>
        <h4>Qualifications:</h4>
        <ul>
            <li>Flexible to emergencies</li>
            <li>Available to attend on-campus for multiple occasions</li>
        </ul> 

        <!-- <h2><b>Programs Core</b></h2>
        <h4>Directly works with the Programs Heads and the entire core team.</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Acts as the bridge between the programs head and other committees of the core team in order to ensure alignment with the event preparations.</li>
            <li>Serves as Project Director should the Project Director be absent or can no longer fulfill.</li>
            <li>Collaborates with the Programs Heads in fulfilling their duties and executing their provided delegations  during the event planning phase and event execution phase.</li>
            <li>Assists in the overall execution of event operations during the event proper.</li>
            <li>Communicates with other committees of the core team for any concerns or needs in regard to the program flow.</li>
            <li>Providing support in streamlining the overall program flow in order to mitigate any difficulties that may arise.</li>
            <li>Assisting in the facilitation of dry runs for the event to mitigate any concerns that may potentially arise during the event.</li>
        </ul> -->

        <h2><b>Logistics Officer Pool</b></h2>
        <h4>Works directly with the VP for Events, Assigned AVP for Event, Project Core Team.</h4>
        <h4>Responsibilities for Online Event:</h4>
        <ul>
            <li>In-charge of finding an appropriate platform for the event</li>
            <li>Tests the software and needed files for the program beforehand</li>
            <li>Assists in the implementation of the program flow</li>
            <li>Creating a contingency plan</li>
            <li>Assists Programs in conducting a test run 1 week prior to the event</li>
        </ul>
        <h4>Responsibilities for Onsite Event:</h4>
        <ul>
            <li>In-charge of acquiring all the equipment or any logistical needs for the event (Materials, Important Files, Sound System, Tables and Chairs, etc.)</li>
            <li>Reserving venues for the event</li>
            <li>Serves as the main representative or contact person in reserving venues (on-campus and off-campus events)</li>
            <li>Directly communicates with Programs Head on how to execute the program flow through the operations schedule</li>
        </ul>
        <h4>Qualifications:</h4>
        <ul>
            <li>Available to attend on-campus for multiple occasions</li>
        </ul>

        <h2><u><b>Events Descriptions</b></u></h2>

        <!-- <h3><b>Jumpstart </b>(open to Sophomores ONLY)</h3>
        <p>Jumpstart is an annual event by Ateneo MISA to welcome the freshman batch into the MIS community and give a glimpse of student life in the Department of Information Systems and Computer Science (DISCS).</p>

        <h3><b>Leadership Development Bootcamp</b></h3>
        <p>The Leadership Development Seminar is a multi-day bootcamp where MISAns who aspire to become leaders will be trained with the relevant skills in preparation for taking on second and third-level officer roles within the organization.</p> -->

        <!-- <h3><b>Tambay Week</b></h3>
        <p>Tambay Week is an annual weeklong casual get-together where MISAns get to hang out with each other and engage in team dynamics activities.</p> -->

        <h3><b>Tambayan sa RLab</b></h3>
        <p>Tambayan sa RLab is fireside chat that focuses on building relationships with our Alumni community. Here, MISA members are given the opportunity to listen from and interact with professors, alumni, and BETA members on varying topics.</p>

        <h3><b>HEX</b></h3>
        <p>HEX is a series of talks where alumni and professionals working in the field of IT/MIS share their firsthand experience and insights to prepare MISAns for their future careers.</p>

        <h3><b>CoLab</b></h3>
        <p>CoLab is Ateneo MISA's primary Information Management Advocacy program targeted at sectors outside of the university. In line with MISA's mission, the program aims to inform, form, and transform the society through proactive engagement in projects utilizing IT.</p>

        <h3><b>Net Night and Career Fair</b></h3>
        <p>Networking Night is an event that aims to connect MISAns with co- members, alumni, professors, and companies in the diverse field of MIS. It is a night to provide key opportunities for career development. This year, we hope to incorporate a Career Fair into the program (to be further developed with this year’s PDs and Marketing BETA).</p>

        <h3><b>IM Summit</b></h3>
        <p>IM Summit is Ateneo MISA’s flagship project, which consists of a multi-day competition that showcases how efficient information technology and management can be used to solve business and organizational problems.</p>

        <h3><b>YEP</b></h3>
        <p>At the end of the academic year, MISA organizes the MISA Rewind as a year-ender event to cap off the events and initiatives for the year. This event gives MISAns the chance to reminisce and celebrate the organization’s achievements on a sweet note with their fellow MISAns.</p>

        <!-- <h2><b>Organization Safety and Compliance Liaison Officer (OSCLO)</b></h2>
        <h4>Works directly with the VP for Events, Assigned AVP for Event, Project Core Team.</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>To attend the Coordination Meeting with the Organization Head, the Project Head of the project requested to be conducted onsite, and the OSA Formator assigned to their organization.</li>
            <li>To facilitate the accomplishment of the Self-Assessment Checklist on Readiness of Student Organization to Conduct Onsite Activities and its submission to OSA.</li>
            <li>To coordinate with and assist their OSA formator, who will be present during the onsite activity, in monitoring their organization’s adherence to health protocols.</li>
        </ul>

        <h2><b>Logistics Core</b></h2>
        <h4>Works directly with Logistics Heads and Programs committee.</h4>
        <h4>Responsibilities:</h4>
        <ul>
          <li>Acts as the bridge between the logistics head and other committees of the core team in order to ensure alignment with the event preparations.</li>
          <li>Collaborates with the Logistics Heads in fulfilling their duties and executing their provided delegations during the event planning phase and event execution phase.</li>
          <li>Provides technical support during the event (i.e. setting up conference calls, breakout rooms, scheduling online Webinars, etc).</li>
          <li>Collaborates with the Programs Committee to ensure alignment with the execution of the program in accordance to the prepared program flow.</li>
          <li>Provides logistical support to each committee of the core team for smoother event preparations.</li>
          <li>Assists in the facilitation of dry runs for the event to mitigate any concerns that may potentially arise during the event.</li>
        </ul> -->

        <!-- <h2><b>Participant Relations Manager (2)</b></h2>
        <h4>Works directly with the Program Heads, Logistic Heads, Organizational Relations Head, and Subcore committees.</h4>
        <h4>Responsibilities:</h4>        
        <ul>
          
          <li>In charge of the overall event registration as well as the handling of the participants’ needs and ensuring that they are updated accordingly regarding any information for the event.</li>
          <li>Manages the registration operations for participants.</li>
          <li>Addresses and manage the logistical concerns of the participants.</li>
          <li>Disseminates critical information and announcements about the event to the participants.</li>
          <li>Manages the distribution of certificates, awards, and prizes to participants.</li>
       </ul> -->

        <!-- BETA POSITIONS -->
        <!-- <h2><b>Associate Vice President for Events Management (4-5)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Oversees all the organization’s internal events (those that cater to the involvement and development of MISA’s members) and external events (those that promote the organization’s thrusts to the Ateneo community and to other wider sectors)</li>
            <li>Ensures each event’s efficient planning and effective implementation are in line with the organization’s mission and vision</li>
            <li>Facilitates training sessions for officers of the cluster to provide a foundation for events planning</li>
            <li>Conducts consultations during the planning phase, as needed, and post-consultations with officers to maintain healthy work relationships</li>
            <li>Tracks the progress of each event through the Project Management System per core team</li>
            <li>Ensures proper implementation of all event-based projects and activities in accordance with the rules and guidelines of the Council of Organizations of the Ateneo - Manila (COA) and the Office of the Student Activities (OSA)</li>
            <li>Relays concerns from the core team to the Vice President for Events</li>
            <li>Trains, oversees, and communicates with the Project Director, Deputy Project Director, Programs Head/s, and Logistics Head/s</li>
            <li>Acts as a liaison in core team meetings on behalf of the Events Cluster</li>
            <li>Assumes the position of Project Director, Deputy Project Director, Programs Head, Logistics Head, or Organization Safety and Compliance Liaison Officer (OSCLO) if there are no applications for the aforementioned positions</li>
        </ul> -->

        <!-- FOOTNOTES? -->
        <br>
        <p></p>
    </div>
</template>

<script>
export default {
    name: 'PrimerEvents'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>
